import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { UsuarioTipo } from '@app/models/usuario-tipo.model';
import { UsuarioTipoPermissao } from '@app/models/util/usuario-tipo-permissao';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-usuario-tipo-form',
  templateUrl: './usuario-tipo-form.component.html',
  styleUrls: ['./usuario-tipo.component.scss']
})
export class UsuarioTipoFormComponent implements OnInit {

  aguardandoSolicitacao = false;

  lstErros: string[];
  titulo: string;
  usuarioTipo: UsuarioTipo = new UsuarioTipo();
  usuarioTipoPermissao: UsuarioTipoPermissao[] = [];
  itemSelecionado: string;

  checkCadastros: boolean;
  checkProcessos: boolean;
  checkAgenda: boolean;
  checkFinanceiro: boolean;
  checkPeticao: boolean;
  checkRelatorios: boolean;
  checkConfiguracoes: boolean;

  checkPermissoesProcesso: boolean;
  checkPermissoesFinanceiro: boolean;
  checkPermissoesFinanceiroProcesso: boolean;
  checkPermissoesOutros: boolean;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private usuarioTipoService: UsuarioTipoService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let id = params['id'];
      this.titulo = id ? 'Editar Tipo de Usuário' : 'Novo Tipo de Usuário';
      this.usuarioTipo.Id = id ? id : 0;

      this.preencheMenu(id);
      this.listaDePermissao(id);

      if (!id)
        return;

      this.usuarioTipoService.obterPorId(id).subscribe(
        data =>  {
          this.usuarioTipo.Descricao = data.Descricao;
          this.usuarioTipo.Padrao = data.Padrao;
        },
        () => this.toastr.error("Erro ao buscar tipo de usuário", "Tente novamente!"));
      });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.usuarioTipoService.gravar(this.usuarioTipo, this.usuarioTipoPermissao).toPromise().then(
      () => this.router.navigate(["./configuracoes/usuario-tipo"]),
      (data: any) => {
        if (data.error){
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }

  preencheMenu(usuarioTipoId: number) {
    this.usuarioTipoService.obterOpcoesDeMenu(usuarioTipoId, true, true).subscribe(data => this.usuarioTipo.Menus = data);
  }

  public selecionarTodos(areaMenu) {
    this.usuarioTipo.Menus.filter(x => x.LocalDoMenu == areaMenu).forEach(element => { element.Selecionado = this.obterTrueOrFalse(areaMenu) });
  }
  
  public seleciona(menu) {
    this.usuarioTipo.Menus.find(x => x.LocalDoMenu == menu.LocalDoMenu && x.Caminho == menu.Caminho).Selecionado = !menu.Selecionado;
  }

  obterTrueOrFalse(areaMenu) {
    switch (areaMenu) {
      case 0:
        return this.checkCadastros;
      case 1:
        return this.checkProcessos;
      case 2:
        return this.checkAgenda;
      case 3:
        return this.checkFinanceiro;
      case 4:
        return this.checkPeticao;
      case 5:
        return this.checkRelatorios;
      case 6:
        return this.checkConfiguracoes;
    }
  }
  
  obterTrueOrFalsePermissoes(local){

    switch(local){
      case 0:
        return this.checkPermissoesProcesso;
      case 1:
        return this.checkPermissoesFinanceiro;
      case 2:
        return this.checkPermissoesFinanceiroProcesso;
      case 3:
        return this.checkPermissoesOutros;
    }
  }

  listaDePermissao(id: any){

      this.usuarioTipoService.MenuUsuarioTipoPermissoes(id).toPromise().then(data => {
      this.usuarioTipoPermissao = data;
      });
  }

  public selecionaTipoPermissao(permissao: UsuarioTipoPermissao) {

    this.usuarioTipoPermissao.find(x => x.Descricao == permissao.Descricao).Selecionado = !permissao.Selecionado;

  }

  public selecionarTodosTipoPermissao(local) {

    this.usuarioTipoPermissao.filter(x => x.Local == local).forEach(element => { element.Selecionado = this.obterTrueOrFalsePermissoes(local) });

  }
}
